import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { AuthService } from '../../../core/auth.service';
import { HELP_CLINIC_PROFILE } from '../../../shared/constants/help-buttons';
import { PopoverService } from '../../../shared/popover/popover.service';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { DialogComponent } from '../../../dialog/dialog.component';
import { SelfReportsService } from '../self-reports.service';
import { BaseComponent } from '../../../shared/base.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'sr-configuration-modal-component',
    templateUrl: './sr-configuration-modal.component.html',
    styleUrls: ['./sr-configuration-modal.component.scss'],
})
export class SrConfigurationModalComponent implements OnChanges {
    @ViewChild('multipleSymptomsModal', {static: false}) multipleSymptomsModal: ModalDirective;
    @ViewChild('dialog',  { static: false}) dialog: DialogComponent;
    SrConfigSub: Subscription;

    @Input() params: Object;
    @Input() formLoading: boolean;
    @Input() isLoading: boolean;
    @Input() isUpdated: boolean;
    @Input() form: FormGroup;
    @Input() fb: FormBuilder;
    @Input() errorMessage: string[];
    @Input() responseMessage: string;
    @Input() formSubmitted: boolean;
    @Input() languages: Object[];
    @Input() itemLanguage: string;
    @Input() selfReports: Object[];
    @Input() domains: Object[];
    @Input() feelings: Object[];
    @Input() groupsData: Object[];
    @Input() parentGroups: Object[];
    @Input() filteredDomains: Object[];
    @Input() filteredFeelings: Object[];
    @Input() authService: AuthService;
    @Input() token: string;
    @Input() helpRawData = '';
    @Input() step: number;
    @Input() totalSteps: number;
    @Input() circumstances: Object[];

    @Output() hideModal = new EventEmitter<any>();
    @Output() submit = new EventEmitter<any>();
    @Output() openFormModal = new EventEmitter<any>();
    @Output() activateConfirmationModal = new EventEmitter<any>();
    @Output() delete = new EventEmitter<any>();
    @Output() changeStep = new EventEmitter<any>();

    HELP_CLINIC_PROFILE = HELP_CLINIC_PROFILE;
    orderedDomains: any;
    SYMPTOMTABS = [
        {
            type: 'prescreening',
            name: 'Prescreening'
        }];
    selectedDomains: any;
    activeTab = null;
    triggerPointIndex: number = 1;
    groupSelectedIndex: number = 0;
    points: number[] = [0, 1, 2, 3, 4, 5];
    finalValue: number = 1;
    checkedFeelings = [];
    isAnanmestic: boolean;
    feelingsIdSelectedByGroup: any[] = [];
    feelingsSelectedByGroup: any[] = [];
    domainIds = [];
    checked = false;
    acuteableFeelings: any;
    ananableFeelings: any;
    circumstanceRequired = false;
    showWarning = false;
    isUpdating = false;

    @ViewChild('formDirective') private formDirective: NgForm;

    constructor(
        public popoverService: PopoverService,
        public translate: TranslateService,
        public selfReportService: SelfReportsService
    ) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['groupsData'] || changes['totalSteps']) {
            if (changes['totalSteps'] && this.totalSteps && this.totalSteps === this.step) {
                this.step = this.totalSteps - 1;
                return this.selectTab(this.step);
            }
            return this.initData();
        }

        if (changes['params'] && this.formDirective) {
            this.showWarning = false;
            this.formDirective.resetForm();
        }

        if (changes['isUpdated'] && this.isUpdated) {
            this.SYMPTOMTABS = [
                {
                    type: 'prescreening',
                    name: 'Prescreening'
                }];
            this.showWarning = false;
        }
        // set helpTemplates
        this.popoverService.setHelpContent(this.helpRawData);
    }

    //Getting form array
    get getGroups() {
        let groups = this.form.get('groups') as FormArray;
        return groups;
    }

    initData() {
        this.feelingsSelectedByGroup = [];
        this.feelingsIdSelectedByGroup = [];
        this.checkedFeelings = [];
        this.domainIds = [];

        this.filteredFeelings = this.feelings;
        if(this.groupsData.length < 1){
            this.feelingsSelectedByGroup[0] = [];
            this.feelingsIdSelectedByGroup[0] = [];
        }
        else{
            for (let index in this.groupsData) {
                this.feelingsSelectedByGroup.push(this.groupsData[index]['feelings']);
                this.feelingsIdSelectedByGroup.push(_.map(this.groupsData[index]['feelings'], 'id'));
                this.checkedFeelings[index] = [];
            }
        }
        while(this.totalSteps > this.SYMPTOMTABS.length){
            this.addOptionTab(false);
        }
        if(this.step > this.totalSteps){
            this.step = this.totalSteps;
        }
        this.activeTab = this.SYMPTOMTABS[this.step]['name'];
        this.isUpdating = (this.SYMPTOMTABS.length > this.totalSteps) ? true : false;
        this.SrConfigSub = this.form.valueChanges.subscribe((res) => {
            this.isUpdating = res['sr_custom_id'] || (this.SYMPTOMTABS.length > this.totalSteps) ? true : false;
        });
    }

    // Adding Dinind
    addNewGroupData() {
        this.getGroups.push(
            this.fb.group({
                id: new FormControl({value: null, disabled: false}, []),
                name: new FormControl({value: null, disabled: false}, [Validators.required, <any>Validators.minLength(3)]),
                trigger_no: new FormControl({value: null, disabled: false}, [<any>Validators.required, <any>Validators.min(1), Validators.pattern('^[0-9]*$')]),
                parent_id: new FormControl({value: null, disabled: false}, []),
                min_age: new FormControl({value: null, disabled: false}, []),
                max_age: new FormControl({value: null, disabled: false}, []),
                feelings: new FormControl({value: null, disabled: false}, [Validators.required])
            })
        );
        this.feelingsSelectedByGroup.push([]);
        this.checkedFeelings.push([]);
    }

    deleteNewGroupData(i) {
        this.getGroups.removeAt(i);
        this.feelingsSelectedByGroup.splice(i, 1);
        this.feelingsIdSelectedByGroup.splice(i, 1);
        this.checkedFeelings.splice(i, 1);
    }

    feelingById(feeling, feelingInGroup) {
        return _.find(feelingInGroup, {id: feeling['id']});
    }

    feelingIDsByGroup(groupData) {
        return _.map(groupData.controls['feelings'].value, 'id');
    }

    getAcuteableFeelings(feelingIds, data){
        let acuteableFeelings = _.filter(data, function (feeling) {
            return feeling['acuteable'] && feelingIds.indexOf(feeling['id']) > -1
        });
        return acuteableFeelings;
    }

    getAnanableFeelings(feelingIds, data){
        let ananableFeelings = _.filter(data, function (feeling) {
            return feelingIds.indexOf(feeling['id']) > -1 && (feeling['anamnestic_feeling_id'] !== feeling['id'] || feeling['acuteable'] === 0)
        });
        return ananableFeelings;
    }

    collectFeelings(item) {
        if(!this.domainIds || !this.domainIds.length){
            this.filteredFeelings = this.feelings;
            return;
        }
        this.filteredFeelings = _.filter(this.feelings, function (feeling) {
            return item.value.indexOf(feeling?.domain_id) > -1;
        });
    }

    removeFeeling(feeling, index) {
        this.isUpdating = true;
        let feelingsIdSelectedByGroup = _.cloneDeep(this.feelingsIdSelectedByGroup[index]);
        let feelingsSelectedByGroup = _.cloneDeep(this.feelingsSelectedByGroup[index]);
        _.remove(feelingsIdSelectedByGroup, function (item) {
            return item == feeling['id'];
        });
        _.remove(feelingsSelectedByGroup, function (item) {
            return item.id == feeling['id'];
        });
        this.checkedFeelings[index]?.splice(this.checkedFeelings[index].indexOf(feeling['id']), 1);
        this.feelingsIdSelectedByGroup[index] = feelingsIdSelectedByGroup;
        this.feelingsSelectedByGroup[index] = feelingsSelectedByGroup;
    }

    switchState(feeling, index) {
        return false;
    }

    selectTab(tabIndex) {
        if(!this.form.valid || this.isUpdating){
            this.showWarning = true;
            return false;
        }
        const data = {
            step: tabIndex,
            id: this.params['id']
        };
        this.changeStep.emit(data);
        if(this.SrConfigSub){
            this.SrConfigSub.unsubscribe();
        }
        this.initData();
    }

    addOptionTab(switchTab = true, create = false) {
        const nextTab = this.SYMPTOMTABS.length;
        const newTab =
            {
                type: 'layer_' + (nextTab + 1),
                name: 'Layer ' + (nextTab + 1)
            };

        this.SYMPTOMTABS.push(newTab);
        if(create){
            this.step++;
        }
        return create ? this.selectTab(nextTab) : true;
    }

    deleteOptionTab(switchTab = true){
        this.SYMPTOMTABS.splice(this.totalSteps, this.SYMPTOMTABS.length - this.totalSteps);
        this.step = this.totalSteps - 1;
        return switchTab ? this.selectTab(this.step) : true;
    }
    // display modal
    openMultipleModal(feelings, index): void {
        this.groupSelectedIndex = index;
        // prevent users from clicking outside to close the customModal since that does not set the url correctly
        this.multipleSymptomsModal.config.backdrop = false;
        this.multipleSymptomsModal.config.ignoreBackdropClick = true;
        this.multipleSymptomsModal.config.keyboard = false;
        // this ensures the form is displayed only when the data is ready
        if (this.params['action'] !== 'delete' && this.params['action'] !== 'activate') {
            // if the form opened belongs to the component different from the component where it's opened
            this.formLoading = false;
        }
        // hide the app loading icon
        this.multipleSymptomsModal.show();
        this.acuteableFeelings = this.getAcuteableFeelings(this.checkedFeelings[this.groupSelectedIndex], this.feelingsSelectedByGroup[this.groupSelectedIndex]);
        this.ananableFeelings = this.getAnanableFeelings(this.checkedFeelings[this.groupSelectedIndex], this.feelingsSelectedByGroup[this.groupSelectedIndex]);
    }

    hideMultipleModal(){
        this.multipleSymptomsModal.hide();
    }
    toggleSelectedFeeling(feeling, index, $event) {
        const value = $event.target.checked;
        const id = feeling['id'];
        if (!value && this.checkedFeelings[index].indexOf(id) > -1) {
            this.checkedFeelings[index].splice(this.checkedFeelings[index].indexOf(id), 1);
            return;
        }
        if (!this.checkedFeelings[index] || !this.checkedFeelings[index].length) {
            this.checkedFeelings[index] = [id];
            return;
        }
        this.checkedFeelings[index].push(id);
    }

    toggleFeeling(feeling, groupIndex) {
        const feelingId = feeling.id;
        this.isUpdating = true;
        if (this.feelingsIdSelectedByGroup[groupIndex].indexOf(feelingId) > -1) {
            let selectedFeeling = _.cloneDeep(feeling);
            selectedFeeling['trigger_point'] = 1;
            selectedFeeling['is_acute'] = 1;
            if (this.feelingsSelectedByGroup.length) {
                this.feelingsSelectedByGroup[groupIndex].push(selectedFeeling);
                return;
            }
            this.feelingsSelectedByGroup.push([selectedFeeling]);
            return;
        }
        return this.removeFeeling(feeling, groupIndex);
    }

    onStepChange($event: any) {
        this.triggerPointIndex = +$event.value;
        this.finalValue = this.points[this.triggerPointIndex];
    }

    getSelectedFeelings() {
        const feelingIds = this.form.controls.items.value;
        let selectedFeelings = _.filter(this.feelings, function (feeling) {
            return feelingIds.indexOf(feeling.id) > -1;
        });
        return selectedFeelings;
    }

    updateFeelingsData() {
        const selectedFeelingsId = this.checkedFeelings[this.groupSelectedIndex];
        for (let index in selectedFeelingsId) {
            let updatedData = _.find(this.feelingsSelectedByGroup[this.groupSelectedIndex], {id: selectedFeelingsId[index]});
            if (this.isAnanmestic && _.find(this.ananableFeelings, {id: updatedData['id']})) {
                updatedData['is_acute'] = 0;
            }
            if (!this.isAnanmestic && _.find(this.acuteableFeelings, {id: updatedData['id']})) {
                updatedData['is_acute'] = 1;
                updatedData['trigger_point'] = this.finalValue;
            }
        }
        this.checkedFeelings[this.groupSelectedIndex] = [];
        this.feelingsSelectedByGroup[this.groupSelectedIndex].forEach(
            item => item['isChecked'] = false
        );
        this.isUpdating = true;
        return this.multipleSymptomsModal.hide();
    }


    submitData() {
        if (this.form.controls['show_circumstances'].value && this.form.controls['circumstance_ids'].value.length === 0) {
            this.circumstanceRequired = true;
            return;
        }

        for (let index in this.feelingsSelectedByGroup) {
            let group = this.form.controls['groups']['controls'][index];
            group.controls['feelings'].setValue(this.feelingsSelectedByGroup[index]);
        }
        if(this.form.valid){
            this.isUpdating = false;
        }
        this.circumstanceRequired = false;
        return this.submit.emit();
    }

    hide() {
        this.SYMPTOMTABS = [
            {
                type: 'prescreening',
                name: 'Prescreening'
            }];
        this.step = 0;
        this.activeTab = this.SYMPTOMTABS[this.step]['name'];
        this.SrConfigSub.unsubscribe();
        this.isUpdating = false;
        return this.hideModal.emit();
    }

    updateCircumstance(value, id) {
        let ids = this.form.controls['circumstance_ids'].value;
        if (value) {
            ids.push(id);
        } else {
            ids = ids.filter(item => item !== id);
        }
        this.form.controls['circumstance_ids'].setValue(ids);
    }

    toggleMatSelect($event){
        this.form.controls['searchTxt'].setValue('');
    }

    deleteLatestTab(params: Object) {
        if(!this.dialog){
            return;
        }

        const dialog = this.dialog.openConfirm(params);
        dialog.onSubmit(() => {
            this.isLoading = true;

            this.selfReportService.deleteLatestTab(params['id'])
                .subscribe(
                    response => {
                        const message = response['message'];
                        if (message) {
                            dialog.showAlert(message);
                        }
                        this.totalSteps--;
                        dialog.hideModal();
                        this.deleteOptionTab();
                        this.isLoading = false;
                        this.isUpdating = false;
                    },
                    error => {
                        dialog.showAlert(error.error.error);
                        this.isLoading = false;
                    }
                );
        });

        dialog.onCancel(() => {
        });
    }
}
